import * as React from 'react';
import Link from '@src/components/link';
import InnerWrapStore from './store';
import Page from '../../components/page';
import wrapStore from '@src/utils/wrap-store';
import InnerFloatRight from '../inner-float-right';
import CommonHeader from '@src/business-components/common-header';
import CommonFooterModal from '@src/business-components/common-footer-modal';
import ScrollToTop from '@src/components/scroll-top';
import cx from 'classnames';

const styles = require('./index.less');

const InnerWrap = ({ store, children, props }) => {
  store.use();

  return (
    <Page className={styles.root}>
      <CommonHeader store={store.commonHeaderStore} />
      <div className={styles.innerKv} style={{ backgroundImage: `url(${store.innerBg})` }}>
        <div className={styles.innerContent}>
          <div className={styles.title}>
            <img src={store.titles[store.title]} alt="" />
          </div>
          <div className={styles.breadcrumb}>
            <div className={cx(styles.breadcrumbIndex, styles.breadcrumbItem)}>
              <Link onClick={() => store.goto('/')}>官网首页</Link>
              <span>{'>'}</span>
            </div>
            {store.breadcrumb.map((item, index) => {
              return (
                <div className={styles.breadcrumbItem} key={index}>
                  <Link onClick={() => store.goto(item.link)}>{item.title}</Link>
                  <span>{'>'}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.children}>{children}</div>
      <div className={styles.innerFooter}>
        <div className={styles.innerFooterContent}>
          <div className={styles.innerFooterTitle}>关于《剑侠世界4：无限》</div>
          <div className={styles.innerFooterDesc}>
            一代人的江湖，就是剑侠。《剑侠世界4：无限》是西山居打造的剑侠世界MMO收官之作。游戏延续剑侠系列家族群战、经典门派、自由交易、好友社交与江湖恩怨等经典体验，并通过无缝大江湖、轻负担养成，打造一场属于剑侠玩家的终极江湖盛宴。现在，无数家族已经集结，全新江湖等你体验。
          </div>
        </div>
        <CommonFooterModal />
      </div>

      <InnerFloatRight store={store.innerFloatRightStore} />
      <ScrollToTop />
    </Page>
  );
};

export default wrapStore(InnerWrap, InnerWrapStore);
